// Update your EventTile component with this design:
import moment from "moment";
import React, { useState, useEffect } from "react";

export default function EventTile(props) {
  const [data, setData] = useState(props.data);
  const [url, setUrl] = useState(props.url);
  let lang = props.state.language;

  useEffect(() => {
    setData(props.data);
    setUrl(props.url);
  }, [props.data, props.url]);

  const fetchDetails = (id) => {
    if (props.fromHome) {
      sessionStorage.setItem("continueFrom", "events");
    }
    let path = `/event/${id}`;
    props.history.push(path);
  };

  // Format date for the badge
  const formatDateForBadge = (dateString) => {
    if (!dateString) return { day: "?", month: "???" };
    try {
      const date = moment(dateString, "DD-MM-YYYY");
      return {
        day: date.format("D"),
        month: date.format("MMM").toUpperCase()
      };
    } catch (e) {
      return { day: "?", month: "???" };
    }
  };

  const dateBadge = formatDateForBadge(data[lang]?.eventDate);

  return (
    <div className="event-tile-box-container">
      <div className="event-preview-img">
        <img 
          src={`${data[lang]?.event_image || '/resources/img/event-placeholder.jpg'}`} 
          className="event-prv" 
          alt={data[lang]?.Title || "Event"} 
          onError={(e) => {
            e.target.src = '/resources/img/event-placeholder.jpg';
          }}
        />
        {/* <div className="event-date-badge">
          <div className="date-day">{dateBadge.day}</div>
          <div className="date-month">{dateBadge.month}</div>
        </div> */}
      </div>

      <div className="event-tile-data-container">
        <div className="event-tile-box-title">{data[lang]?.Title}</div>

        <div className="new-event-info-details-list">
          <div className="info-row">
            <div className="info-icon-container">
              <img src="/resources/img/location.png" className="info-icon" alt="Location" />
            </div>
            <div className="info-text" title={data[lang]?.location}>
              {data[lang]?.location || "Venue to be announced"}
            </div>
          </div>

           <div className="info-row"> 
             <div className="info-icon-container">
              <img src="/resources/img/date.png" className="info-icon" alt="Date" />
            </div>
            <div className="info-text">
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ marginBottom: '2px' }}>
                  <strong>Start Date:</strong> {data[lang]?.eventDate || "TBD"}
                </div>
                <div>
                  <strong>End Date:</strong> {data[lang]?.event_date_to || "TBD"}
                </div>
              </div>
            </div> 
           </div> 
        </div>

        {Number(data[lang]?.paid) > 0 && data[lang]?.event_organized_type === "kspace" && (
          <div className="price-tag">
            <div className="price-label">Registration Fee</div>
            <div className="price-value">
              ₹{Number(data[lang]?.paid).toLocaleString('en-IN')}
            </div>
          </div>
        )}

        {/* {Number(data[lang]?.paid) === 0 && data[lang]?.event_organized_type === "kspace" && (
          <div className="price-tag">
            <div className="price-label">Registration</div>
            <div className="price-value free">FREE</div>
          </div>
        )} */}

        <div className={Number(data[lang]?.paid) > 0 ? "evnt-tile-btns-cont" : "evnt-tile-btn-cont"}>
          <button
            className="read-more-btn-event"
            onClick={(e) => {
              fetchDetails(data[lang]?.slug);
            }}
          >
            <span>Read More</span>
          </button>
          
          {/* {data[lang]?.event_organized_type === "kspace" && (
            <button
              className="book-now-btn-event"
              onClick={(e) => {
                fetchDetails(data[lang]?.slug);
              }}
            >
              <span>
                {Number(data[lang]?.paid) > 0 ? "Register Now" : "Join Now"}
              </span>
            </button>
          )} */}
        </div>
      </div>
    </div>
  );
}